import React from 'react';
import { createRoot } from 'react-dom/client';
import MyResponsiveChoropleth from './components/GeoMap';
import './styles.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <MyResponsiveChoropleth />
    </React.StrictMode>
);
